<script>
    import {createEventDispatcher} from 'svelte';
    import Modal from "./Modal.svelte";
    import Icono from "../UI/Icono.svelte";
    import {nombreCompleto} from '../../Modelos/Trabajador';
    import Boton from "./Boton.svelte";

    export let id;
    export let label;
    export let trabajadores;
    export let icono = 'people';
    export let value = null;
    export let placeholder = 'Escribe para buscar…';

    let texto = '';

    const dispatch = createEventDispatcher();

    let visible = false;
    let touched = false;
    let valorMostrado = '';

    $: valorMostrado = value ? value.nombre : '';

    let trabajadoresConNombre, filtrados;
    $: trabajadoresConNombre = trabajadores.map(x => ({...x, nombreCompleto: nombreCompleto(x)}));
    $: filtrados = trabajadoresConNombre.filter(x => {
      return x.nombreCompleto.toLowerCase().indexOf(valorMostrado.toLowerCase()) >= 0
    });

    const filtra = e => valorMostrado = e.target.value;

    const seleccionaTrabajador = trabajador => dispatch('change', trabajador);
</script>

<style>
    .form-control {
        position: relative;
        padding: 0.5rem 0 0;
        width: 100%;
        margin: 0.25rem 0;
    }

    .campo {
        border: 2px solid var(--bordes);
        border-radius: 3px 3px 0 0;
        display: flex;
        position: relative;
    }

    .icono {
        flex: 0 0 auto;
        background: var(--bordes);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--negro);
        padding: .25rem;
    }

    input {
        display: block;
        width: 100%;
        font: inherit;
        border: none;
        background: white;
        padding: 0.25em 1em;
        transition: border-color 0.1s ease-out;
    }

    input:focus {
        border-color: #e40763;
        outline: none;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .filtrados {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        border-left: 1px solid var(--naranja-clarito);
        border-right: 1px solid var(--naranja-clarito);
        box-shadow: 0 6px 6px -6px rgba(0, 0, 0, .3);
    }

    .filtrados button {
        border: 0;
        display: block;
        font: inherit;
        padding: .5em;
        transition: .3s;
        width: 100%;
        background: #fff;
        border-bottom: 1px solid var(--naranja-clarito);
    }

    .filtrados button:hover {
        background: var(--naranja-clarito);
    }
</style>

<div class="form-control" on:click={() => visible = true}>
    <label for={id}>{label}</label>
    <div class="campo">
        {#if icono}
            <div class="icono">
                <i class="material-icons">{icono}</i>
            </div>
        {/if}

        <input type="text" id={id} value={valorMostrado} on:input={filtra}
               {placeholder}/>
    </div>
    {#if filtrados.length && valorMostrado}
        <div class="filtrados">
            {#each filtrados as trabajador}
                <button on:click={() => seleccionaTrabajador(trabajador)}>
                    {trabajador.nombreCompleto}
                </button>
            {/each}
        </div>
    {/if}
</div>